<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    {{ 'SALES.SALES_OFFERS_FORM.FORM_TITLE' | translate }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<form
  id="sale-offers-form"
  (ngSubmit)="save()"
  [formGroup]="form"
  novalidate
  class="modal-body p-0 d-flex flex-column"
  (keydown.enter)="$event.preventDefault()"
>
  <ng-scrollbar class="form-body-scroll ps">

  <div class="ps-2 pe-2">
    <div class="row align-items-center mt-2">
      <div class="modal-section-title col-sm-2">Client Request</div>
      <div class="col-sm-3">
        <button
            *ngIf="
              accessService.hasAccess(
                [
                  UserRoleType.RESERVATION_AGENT,
                  UserRoleType.RESERVATION_MANAGER,
                  UserRoleType.CONTRACTING_AGENT,
                  UserRoleType.CONTRACTING_MANAGER,
                  UserRoleType.SALES_AGENT,
                  UserRoleType.SALES_MANAGER,
                  UserRoleType.CUSTOMER_CARE_AGENT,
                  UserRoleType.CUSTOMER_CARE_MANAGER,
                  UserRoleType.FINANCE_AGENT,
                  UserRoleType.FINANCE_MANAGER,
                  UserRoleType.LEAD_GENERATION,
                  UserRoleType.IT,
                  UserRoleType.MARKETING
                ],
                ['sales.finals.items.index']
              )
            "
            type="button"
            class="btn btn-sm btn-primary"
            (click)="openClientHistory(sale.client_id)"
          >
            <i class="fal fa-history"></i>
            {{ 'SALES.SALES_VIEW.CLIENT_HISTORY' | translate }}
          </button>
      </div>
      <div class="col-sm-1 ms-auto d-flex align-items-center justify-content-end" *ngIf="this.currentRequestId">
        <button type="button" class="btn btn-secondary btn-sm" (click)="addBooking()">
          {{ 'SALES.SALES_OFFERS_FORM.ADD_BOOKING' | translate }}
        </button>
      </div>
    </div>
    <kendo-grid
      class="requests-grid mt-2 mb-4"
      [kendoGridBinding]="sale?.requests"
      [style.maxHeight.px]="10 * 26 + 34"
      [selectable]="{ mode: 'single' }"
      [kendoGridSelectBy]="'id'"
      [selectedKeys]="[currentRequestId]"
      [sortable]="true"
      (sortChange)="requestSortChange($event)"
      (rowClick)="setCurrentRequest($event.dataItem.id, $event.dataItem)"
      (cellClick)="setCurrentRequest($event.dataItem.id, $event.dataItem)"
    >
      <kendo-grid-column [width]="40" class="text-center p-1" headerClass="text-center p-1" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <input
            type="radio"
            name="requestSelect"
            [checked]="dataItem.id === currentRequestId"
            (change)="setCurrentRequest(dataItem.id, dataItem)"
          />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="40" class="text-center p-1" headerClass="text-center p-1" [sortable]="false" title="#">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ rowIndex + 1 }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="40" class="text-center p-1" headerClass="text-center p-1" [sortable]="false" title="CR">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.id }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="status_value" title="{{ 'SALES.SALES_OFFERS_FORM.STATUS' | translate }}" [width]="90" [sortable]="true">
      </kendo-grid-column>

      <kendo-grid-column field="check_in" title="{{ 'SALES.SALES_OFFERS_FORM.CHECK_IN' | translate }}" [width]="110" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.check_in | date : env.pipeDateFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="nights" title="{{ 'SALES.SALES_OFFERS_FORM.NIGHTS' | translate }}" [width]="60" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.nights || getNightsCount(dataItem.check_in, dataItem.check_out) }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="check_out" title="{{ 'SALES.SALES_OFFERS_FORM.CHECK_OUT' | translate }}" [width]="110" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.check_out | date : env.pipeDateFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="people" title="{{ 'SALES.SALES_OFFERS_FORM.PEOPLE' | translate }}" [width]="60" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="count" title="{{ 'SALES.SALES_OFFERS_FORM.ROOMS' | translate }}" [width]="60" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="type_value" title="{{ 'SALES.SALES_OFFERS_FORM.TYPE' | translate }}" [width]="120" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="meal_plan_value" title="{{ 'SALES.SALES_OFFERS_FORM.MEAL_PLAN_SHORT' | translate }}" [width]="60" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="hotel_name" title="{{ 'SALES.SALES_OFFERS_FORM.HOTEL' | translate }}" [width]="160" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="budget" title="{{ 'SALES.SALES_OFFERS_FORM.BUDGET' | translate }}" [width]="90" [sortable]="true"></kendo-grid-column>

      <kendo-grid-column field="guest_names_display" title="{{ 'SALES.SALES_OFFERS_FORM.GUEST_NAMES' | translate }}" [width]="160" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.guest_names_display">{{ dataItem.guest_names_display }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="note" title="{{ 'SALES.SALES_OFFERS_FORM.NOTE' | translate }}" [width]="180" [sortable]="true"></kendo-grid-column>
    </kendo-grid>
  </div>
  <div class="modal-top-section ps-2 pe-2">
    <div class="row">
      <div class="col-sm-1">
        <div class="form-group">
          <label>{{ 'SALES.SALES_OFFERS_FORM.OFFER_NAME' | translate }}</label>
          <input
            type="text"
            class="form-control border-raidius-4"
            formControlName="name"
            [ngClass]="{ invalid: !form.get('name').value }"
          />
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'SALES.SALES_OFFERS_FORM.DESCRIPTION' | translate }}</label>
          <input type="text" class="form-control border-raidius-4" formControlName="description" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SALES.SALES_OFFERS_FORM.NOTE' | translate }}</label>
          <input type="text" class="form-control border-raidius-4" formControlName="note" />
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <label>{{ 'SALES.SALES_OFFERS_FORM.CLIENT_COMMENT_TYPE' | translate }}</label>
          <app-type-select
            class="form-control-wrapper-sm"
            [parentFormGroup]="form"
            [groupType]="'sale_offer_client_comment'"
            [passFormControlName]="'client_comment_type_id'"
          ></app-type-select>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SALES.SALES_OFFERS_FORM.CLIENT_COMMENT' | translate }}</label>
          <input type="text" class="form-control border-raidius-4" formControlName="client_comment" />
        </div>
      </div>
      <div class="col-sm-1">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="offer-show-to-web" formControlName="show_to_web" />
          <label class="custom-control-label" for="offer-show-to-web">
            {{ 'SALES.SALES_OFFERS_FORM.SHOW_TO_WEB' | translate }}
          </label>
        </div>
      </div>

      
      <div
        *ngFor="let request of sale?.requests; let I = index"
        class="search-results-wrapper"
        [ngClass]="{ 'd-none': request.id !== currentRequestId }"
      >
        <div *ngIf="request.id === currentRequestId" class="h-100 d-flex flex-column">
          <div class="d-flex filters-row">
            <!--            <div class="ref-number-holder holder">-->
            <!--              <div class="form-group">-->
            <!--                <label>{{ 'SALES.SALES_OFFERS_FORM.REF_NUMBER' | translate }}</label>-->
            <!--                <input-->
            <!--                  type="text"-->
            <!--                  class="form-control form-control-sm"-->
            <!--                  [(ngModel)]="request.filters.ref_number"-->
            <!--                  [ngModelOptions]="{ standalone: true }"-->
            <!--                  (keydown.enter)="getHotelRooms(request)"-->
            <!--                />-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="property-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.PROPERTY' | translate }}</label>

                <app-type-select
                  class="form-control-wrapper-sm"
                  [(model)]="request.filters.property_id"
                  [groupType]="'booking_properties'"
                ></app-type-select>
              </div>
            </div>

            <div class="check-in-holder holder">
              <div class="form-group ">
                <label>{{ 'SALES.SALES_OFFERS_FORM.CHECK_IN' | translate }}</label>
                <p-calendar
                  inputStyleClass="form-control"
                  class="prime-ng-datapicker"
                  styleClass="d-block"
                  monthNavigator="true"
                  yearNavigator="true"
                  dateFormat="yy-mm-dd"
                  baseZIndex="1"
                  [(ngModel)]="request.filters.check_in"
                  [ngModelOptions]="{ standalone: true }"
                  [firstDayOfWeek]="1"
                ></p-calendar>
              </div>
            </div>

            <div class="check-out-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.CHECK_OUT' | translate }}</label>
                <p-calendar
                  inputStyleClass="form-control"
                  class="prime-ng-datapicker"
                  styleClass="d-block"
                  monthNavigator="true"
                  yearNavigator="true"
                  dateFormat="yy-mm-dd"
                  baseZIndex="1"
                  [(ngModel)]="request.filters.check_out"
                  [ngModelOptions]="{ standalone: true }"
                  [firstDayOfWeek]="1"
                ></p-calendar>
              </div>
            </div>

            <div class="event-holder holder">
              <app-event-select
                class="form-control-wrapper-sm"
                [(model)]="request.filters.event"
                [includes]="'venue'"
              ></app-event-select>
            </div>

            <div class="radius-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.RADIUS' | translate }}</label>
                <input
                  type="text"
                  class="form-control text-start border-raidius-4"
                  [(ngModel)]="request.filters.radius"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown.enter)="getHotelRooms(request)"
                />
              </div>
            </div>

            <div class="supplier-holder holder">
              <app-supplier-select
                class="form-control-wrapper-sm"
                [(model)]="request.filters.supplier"
              ></app-supplier-select>
            </div>

            <div class="hotel-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.HOTEL' | translate }}</label>
                <input
                  type="text"
                  class="form-control text-start border-raidius-4"
                  [(ngModel)]="request.filters.hotel"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown.enter)="getHotelRooms(request)"
                />
              </div>
            </div>

            <div class="stars-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.STARS' | translate }}</label>
                <select
                  class="form-control border-raidius-4"
                  [(ngModel)]="request.filters.stars"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <option [ngValue]="null">{{ 'SALES.SALES_OFFERS_FORM.ALL_STARS' | translate }}</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>

            <div class="type-holder holder">
              <div class="form-group">
                <label>{{ 'SALES.SALES_OFFERS_FORM.TYPE' | translate }}</label>
                <app-type-select
                  class="form-control-wrapper-sm"
                  [(model)]="request.filters.type_id"
                  [groupType]="'rooms'"
                ></app-type-select>
              </div>
            </div>

            <!--            <div class="meal-plan-holder holder">-->
            <!--              <div class="form-group">-->
            <!--                <label>{{ 'SALES.SALES_OFFERS_FORM.MEAL_PLAN' | translate }}</label>-->
            <!--                <app-type-select-->
            <!--                  class="form-control-wrapper-sm"-->
            <!--                  [(model)]="request.filters.meal_plan_id"-->
            <!--                  [groupType]="'room_meal_plans'"-->
            <!--                ></app-type-select>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="search-holder text-center">
              <button (click)="getHotelRooms(request)" type="button" class="btn btn-info btn-xs search-btn-margin border-raidius-4">
                {{ 'SALES.SALES_OFFERS_FORM.SEARCH' | translate }}
              </button>
            </div>

            <div class="search-holder text-center ms-1">
              <button
                (click)="advancedHotelSearch(request)"
                type="button"
                class="btn btn-warning btn-xs search-btn-margin border-raidius-4"
              >
                {{ 'SALES.SALES_OFFERS_FORM.ADVANCED' | translate }}
              </button>
            </div>
          </div>

          <div class="results-kendo-grid-wrapper">
            <div class="modal-section-title">Offers</div>
            <div *ngIf="request?.roomsResults?.data?.length <= 0">
              {{ 'SALES.SALES_OFFERS_FORM.SEARCH_NO_RESULTS_MSG' | translate }}
            </div>

            <kendo-grid
              *ngIf="request?.roomsResults?.data?.length > 0"
              [style.height]="'100%'"
              [data]="request?.roomsResults?.getGridData()"
              [pageSize]="request?.roomsResults?.meta?.per_page"
              [pageable]="true"
              [sortable]="true"
              [filterable]="true"
              [filter]="request.state?.filter"
              [sort]="request.state?.sort"
              [skip]="request.state?.skip"
              (dataStateChange)="getHotelRooms(request, $event)"
            >
              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                [width]="50"
                field="id"
                title="{{ 'SALES.SALES_OFFERS_FORM.TABLE_NUMBER_COLUMN_TITLE' | translate }}"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ rowIndex + 1 }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="hotel.name"
                title="{{ 'SALES.SALES_OFFERS_FORM.HOTEL' | translate }}"
                filter="text"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.hotel.name }}

                  <span *ngIf="dataItem?.hotel?.stars">
                    ({{ dataItem.hotel.stars }} <span class="star-ico-wrapper"> <i class="fas fa-star"></i></span>)
                  </span>
                </ng-template>
              </kendo-grid-column>

              <!--              <kendo-grid-column-->
              <!--                class="text-center p-1"-->
              <!--                headerClass="text-center p-1"-->
              <!--                field="events"-->
              <!--                title="{{ 'SALES.SALES_OFFERS_FORM.EVENTS' | translate }}"-->
              <!--              >-->
              <!--                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
              <!--                  <div *ngFor="let event of dataItem.booking?.events; let i = index">-->
              <!--                    <a [routerLink]="['/events/view']" [queryParams]="{ id: event?.id }" target="_blank">-->
              <!--                      {{ event?.formattedName }}-->
              <!--                    </a>-->
              <!--                  </div>-->
              <!--                </ng-template>-->
              <!--              </kendo-grid-column>-->

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.property.value"
                title="{{ 'SALES.SALES_OFFERS_FORM.PROPERTY' | translate }}"
                [width]="60"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-type-select [groupType]="'booking_properties'" [filter]="filter"></app-kendo-type-select>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="100"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="created_at"
                title="{{ 'SALES.SALES_OFFERS_FORM.CREATED_AT' | translate }}"
                filter="date"
                format="{0:dd/MM/yyyy}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    {{ dataItem.created_at.getDate() }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="100"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.offer_deadline"
                title="{{ 'SALES.SALES_OFFERS_FORM.OFFER_DEADLINE' | translate }}"
                filter="date"
                format="{0:dd/MM/yyyy}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    {{ dataItem.booking.offer_deadline | date : env.pipeDateFormat }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.tags"
                [sortable]="false"
                title="{{ 'SALES.SALES_OFFERS_FORM.TAGS' | translate }}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-tag-select [filter]="filter" field="bookingTags"></app-kendo-tag-select>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.note"
                title="{{ 'SALES.SALES_OFFERS_FORM.BOOKING_NOTE' | translate }}"
                [width]="30"
                [sortable]="false"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-sticky-note"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div *ngIf="dataItem?.booking?.note">
                    <ng-template #tipContent><div [innerHTML]="dataItem?.booking?.note"></div></ng-template>
                    <span tooltipClass="with-html" [ngbTooltip]="tipContent" container="body">
                      <i class="fal fa-sticky-note"></i>
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1 no-wrap"
                headerClass="text-center p-1"
                field="min_nights"
                title="{{ 'SALES.SALES_OFFERS_FORM.MIN_NIGHTS' | translate }}"
                [sortable]="false"
              >
                <ng-template kendoGridHeaderTemplate>
                  {{ 'SALES.SALES_OFFERS_FORM.MIN' | translate }} <i class="fas fa-moon nights-ico"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span
                    *ngIf="dataItem.min_nights_from && dataItem.min_nights_to"
                    [ngbTooltip]="
                      dataItem.min_nights_to
                        | amParse : env.apiPipeDateFormat
                        | amDifference : dataItem.min_nights_from : 'days'
                    "
                    container="body"
                  >
                    <strong
                      [ngClass]="{
                        'theme-color-success': isBetween(dataItem.min_nights_from, request.check_in, request.check_out),
                        'theme-color-danger': !isBetween(dataItem.min_nights_from, request.check_in, request.check_out)
                      }"
                    >
                      {{ dataItem.min_nights_from | date : 'dd.MM.yy' }}
                    </strong>

                    -

                    <strong
                      [ngClass]="{
                        'theme-color-success': isBetween(dataItem.min_nights_to, request.check_in, request.check_out),
                        'theme-color-danger': !isBetween(dataItem.min_nights_to, request.check_in, request.check_out)
                      }"
                    >
                      {{ dataItem.min_nights_to | date : 'dd.MM.yy' }}
                    </strong>
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.supplier.name"
                title="{{ 'SALES.SALES_OFFERS_FORM.SUPPLIER' | translate }}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-supplier-select [filter]="filter" [field]="'booking.supplier_id'"></app-kendo-supplier-select>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="80"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="booking.company.abbreviation"
                title="{{ 'SALES.SALES_OFFERS_FORM.COMPANY' | translate }}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-company-select [filter]="filter" [field]="'booking.company_id'"></app-kendo-company-select>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.booking.company.shortName }}
                </ng-template>
              </kendo-grid-column>

              <!--              <kendo-grid-column-->
              <!--                class="text-center p-1"-->
              <!--                headerClass="text-center p-1"-->
              <!--                field="hotel.city"-->
              <!--                title="{{ 'SALES.SALES_OFFERS_FORM.CITY' | translate }}"-->
              <!--              >-->
              <!--                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
              <!--                  {{ dataItem.hotel.city.name }} ({{ dataItem.hotel.city.country.name }})-->
              <!--                </ng-template>-->
              <!--              </kendo-grid-column>-->

              <kendo-grid-column
                [width]="70"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="distance_to_fair"
                [sortable]="true"
                title="{{ 'SALES.SALES_OFFERS_FORM.DISTANCE_TO_FAIR' | translate }}"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.distance_to_fair }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="70"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="hotel.distance_to_center"
                title="{{ 'SALES.SALES_OFFERS_FORM.DISTANCE_TO_CENTER' | translate }}"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [width]="80"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="type.value"
                title="{{ 'SALES.SALES_OFFERS_FORM.TYPE' | translate }}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="40"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="meal_plan.value"
                title="{{ 'SALES.SALES_OFFERS_FORM.MEAL_PLAN_SHORT' | translate }}"
              >
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-kendo-type-select [groupType]="'room_meal_plans'" [filter]="filter"></app-kendo-type-select>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="80"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="check_in"
                title="{{ 'SALES.SALES_OFFERS_FORM.CHECK_IN' | translate }}"
                filter="date"
              >
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span
                    class="fw-bold"
                    [ngClass]="{
                      'theme-color-success': isBefore(dataItem.check_in, request.check_in),
                      'theme-color-danger': !isBefore(dataItem.check_in, request.check_in)
                    }"
                  >
                    {{ dataItem.check_in | date : env.pipeDateFormat }}
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="30"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="nights"
                title="{{ 'SALES.SALES_OFFERS_FORM.NIGHTS' | translate }}"
                [sortable]="false"
                filter="numeric"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-moon nights-ico"></i>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ getNightsCount(dataItem.check_in, dataItem.check_out) }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="80"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="check_out"
                title="{{ 'SALES.SALES_OFFERS_FORM.CHECK_OUT' | translate }}"
                filter="date"
              >
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span
                    class="fw-bold"
                    [ngClass]="{
                      'theme-color-success': isBefore(request.check_out, dataItem.check_out),
                      'theme-color-danger': !isBefore(request.check_out, dataItem.check_out)
                    }"
                  >
                    {{ dataItem.check_out | date : env.pipeDateFormat }}
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="180"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="ref_number"
                title="{{ 'SALES.SALES_OFFERS_FORM.REF_NUMBER_SHORT' | translate }}"
                [sortable]="false"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <!-- така каза Тес в скайп на 13.07.20 12:56-->
                  <ng-container *ngIf="dataItem.ref_number">
                    {{ dataItem.ref_number }}
                  </ng-container>

                  <ng-container *ngIf="!dataItem.ref_number && dataItem?.booking?.ref_number">
                    {{ dataItem.booking.ref_number }}
                  </ng-container>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="30"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="people"
                title="{{ 'SALES.SALES_OFFERS_FORM.PEOPLE' | translate }}"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-user"></i>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center p-1"
                headerClass="text-center p-1"
                field="net_price_eur_avg"
                title="{{ 'SALES.SALES_OFFERS_FORM.NET_PRICE_AVG_NIGHT' | translate }}"
                [width]="110"
              >
                <ng-template kendoGridHeaderTemplate>
                  {{ 'SALES.SALES_OFFERS_FORM.NET_PRICE_AVG_NIGHT' | translate }}<i class="fas fa-moon nights-ico"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div>
                    {{ dataItem.net_price | number : '1.2-2' }}
                    <app-currency-box [currency]="dataItem.net_price_currency"></app-currency-box>
                  </div>
                  <app-currency-converter [value]="dataItem.net_price" [fromCurrency]="dataItem.net_price_currency">
                  </app-currency-converter>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="55"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="available_rooms"
                title="{{ 'SALES.SALES_OFFERS_FORM.ROOMS' | translate }}"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div
                    class="fw-bold"
                    [ngClass]="{
                      'theme-color-danger': dataItem.available_count <= 0,
                      'theme-color-success': dataItem.available_count > 0
                    }"
                  >
                    <span [ngbTooltip]="'SALES.SALES_OFFERS_FORM.ROOMS_AVAILABLE_TOOLTIP' | translate" container="body">
                      {{ dataItem.available_count }}
                    </span>
                    <span [ngbTooltip]="'SALES.SALES_OFFERS_FORM.ROOMS_USED_TOOLTIP' | translate" container="body">
                      ({{ dataItem.count - dataItem.available_count }})
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="70"
                class="text-center p-1"
                headerClass="text-center p-1"
                field="client_price"
                title="{{ 'SALES.SALES_OFFERS_FORM.CLIENT_PRICE_NIGHT' | translate }}"
                [sortable]="false"
              >
                <ng-template kendoGridHeaderTemplate>
                  {{ 'SALES.SALES_OFFERS_FORM.CLIENT_PRICE_NIGHT' | translate }}<i class="fas fa-moon nights-ico"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <input
                    type="text"
                    class="form-control table-form-control-sm form-control-client-price"
                    [(ngModel)]="dataItem.client_price"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="55"
                class="text-center p-1 no-wrap"
                headerClass="text-center p-1"
                field="client_price"
                title="{{ 'SALES.SALES_OFFERS_FORM.ROOM_COUNT' | translate }}"
                [sortable]="false"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <input
                    type="text"
                    class="form-control table-form-control-sm form-control-room-count"
                    [(ngModel)]="dataItem.room_count"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="55">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div class="d-flex flex-nowrap">
                    <button
                      [disabled]="
                        dataItem.room_count < 1 ||
                        dataItem.room_count > dataItem.available_count ||
                        !dataItem.room_count
                      "
                      type="button"
                      class="btn btn-success btn-ico align-top me-1"
                      (click)="addRow(dataItem, request)"
                    >
                      <i class="fal fa-plus"></i>
                    </button>

                    <app-edit-button (click)="editHotelBooking(dataItem.booking, request, dataItem.allotment_id)">
                    </app-edit-button>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-info></kendo-pager-info>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
                <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
                <app-kendo-grid-refresh-button
                  (click)="getHotelRooms(request, request?.state)"
                ></app-kendo-grid-refresh-button>
              </ng-template>
            </kendo-grid>
          </div>
        </div>
      </div>

      <div *ngIf="!currentRequestId" class="select-request-msg mt-4 mb-4">
        <i class="fal fa-arrow-left"></i> {{ 'SALES.SALES_OFFERS_FORM.SELECT_REQUEST_MSG' | translate }}
      </div>

      <ng-scrollbar class="selected-wrapper ps" *ngIf="currentRequestId">
        <div class="d-flex justify-content-between mt-4 mb-2">
          <div class="modal-section-title">{{ 'SALES.SALES_OFFERS_FORM.SELECTED_ROOMS' | translate }}</div>
          <div>
            <button type="button" class="btn btn-primary btn-xs" (click)="addEmptyRow()">
              {{ 'SALES.SALES_OFFERS_FORM.ADD' | translate }}
            </button>

            <button class="btn btn-outline-secondary btn-xs" type="button" (click)="openHotelFinder()">
              {{ 'SALES.SALES_OFFERS_FORM.ADD_WITH_HOTEL' | translate }}
            </button>
          </div>
        </div>

        <div class="table" *ngIf="form.get('items')?.controls.length > 0">
          <thead>
            <tr>
              <th>{{ 'SALES.SALES_OFFERS_FORM.TABLE_NUMBER_COLUMN_TITLE' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.CLIENT_REQUEST' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.HOTEL' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.STARS' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.SUPPLIER' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.COMPANY' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.TYPE' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.MEAL_PLAN_SHORT' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.CHECK_IN' | translate }}</th>
              <th><i class="fas fa-moon nights-ico"></i></th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.CHECK_OUT' | translate }}</th>
              <th class="no-wrap">{{ 'SALES.SALES_OFFERS_FORM.REF_NUMBER_SHORT' | translate }}</th>
              <th>
                <!--              {{ 'SALES.SALES_OFFERS_FORM.PEOPLE' | translate }}-->
                <i class="fas fa-user"></i>
              </th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.CLIENT_PENALTY' | translate }}</th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.SUPPLIER_PENALTY' | translate }}</th>
              <th class="no-wrap">
                {{ 'SALES.SALES_OFFERS_FORM.NET_PRICE_AVG_NIGHT' | translate }}<i class="fas fa-moon nights-ico"></i>
              </th>
              <th class="no-wrap">
                {{ 'SALES.SALES_OFFERS_FORM.CLIENT_PRICE_NIGHT' | translate }}<i class="fas fa-moon nights-ico"></i>
              </th>
              <th>{{ 'SALES.SALES_OFFERS_FORM.ROOM_COUNT' | translate }}</th>
            </tr>
          </thead>
          <tbody *ngFor="let dataItem of form.get('items')?.controls; let rowIndex = index">
            <tr *ngIf="dataItem.get('sale_request_id').value === currentRequestId">
              <td>
                {{ rowIndex + 1 }}
              </td>
              <td>
                {{ dataItem.get('sale_request_id')?.value }}
              </td>
              <td style="width: 180px; max-width: 180px">
                <app-hotel-select
                  class="form-control-wrapper-sm"
                  [parentFormGroup]="dataItem"
                  [hideLabel]="true"
                  (select)="syncAvailableRooms()"
                >
                </app-hotel-select>
              </td>
              <td>
                {{ dataItem.get('hotel')?.value?.stars }}
                <span class="star-ico-wrapper" *ngIf="dataItem.get('hotel')?.value?.stars">
                  <i class="fas fa-star"></i>
                </span>
              </td>
              <td style="width: 140px; max-width: 140px">
                <app-supplier-select class="form-control-wrapper-sm" [parentFormGroup]="dataItem" [hideLabel]="true">
                </app-supplier-select>
              </td>
              <td style="width: 110px; max-width: 110px">
                <app-company-select class="form-control-wrapper-sm" [parentFormGroup]="dataItem" [hideLabel]="true">
                </app-company-select>
              </td>
              <td style="width: 140px; max-width: 140px">
                <app-type-select
                  class="form-control-wrapper-sm"
                  [parentFormGroup]="dataItem"
                  [groupType]="'rooms'"
                  [passFormControlName]="'type_id'"
                  (select)="syncAvailableRooms()"
                >
                </app-type-select>
              </td>
              <td style="width: 100px; max-width: 100px">
                <app-type-select
                  class="form-control-wrapper-sm"
                  [parentFormGroup]="dataItem"
                  [groupType]="'room_meal_plans'"
                  [passFormControlName]="'meal_plan_id'"
                  (select)="syncAvailableRooms()"
                >
                </app-type-select>
              </td>
              <td style="width: 110px">
                <app-date-picker
                  class="form-control-wrapper-sm"
                  [FormControl]="dataItem.get('check_in')"
                  (select)="datesChange(dataItem)"
                >
                </app-date-picker>
              </td>
              <td
                [ngClass]="{
                  'theme-color-danger fw-bolder':
                    getNightsCount(dataItem.get('check_in').value, dataItem.get('check_out').value) <= 0
                }"
              >
                {{ getNightsCount(dataItem.get('check_in').value, dataItem.get('check_out').value) }}
              </td>
              <td style="width: 110px">
                <app-date-picker
                  class="form-control-wrapper-sm"
                  [FormControl]="dataItem.get('check_out')"
                  (select)="datesChange(dataItem)"
                >
                </app-date-picker>
              </td>
              <td style="width: 100px; max-width: 100px">
                <input class="form-control" [formControl]="dataItem.get('ref_number')" />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control table-form-control-sm form-control-people hidden-arrows"
                  [formControl]="dataItem.get('people')"
                  (keyup)="syncAvailableRooms()"
                />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control table-form-control-sm"
                  [formControl]="dataItem.get('client_penalty')"
                />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control table-form-control-sm"
                  [formControl]="dataItem.get('supplier_penalty')"
                />
              </td>
              <td style="width: 160px; max-width: 160px">
                <div class="d-flex">
                  <div class="w-50">
                    <input
                      type="text"
                      class="form-control table-form-control-sm form-control-client-price"
                      [formControl]="dataItem.get('net_price')"
                    />
                  </div>

                  <div class="w-50">
                    <app-currency-select
                      class="form-control-wrapper-sm"
                      [hideLabel]="true"
                      [parentFormGroup]="dataItem"
                      [passFormControlName]="'net_price_currency_id'"
                    >
                    </app-currency-select>
                  </div>
                </div>

                <app-currency-converter
                  [value]="dataItem.get('net_price').value"
                  [fromCurrency]="dataItem.get('net_price_currency').value"
                >
                </app-currency-converter>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control table-form-control-sm form-control-client-price"
                  [formControl]="dataItem.get('price')"
                />
              </td>
              <td class="no-wrap">
                <input
                  type="text"
                  class="form-control table-form-control-sm form-control-room-count"
                  [formControl]="dataItem.get('count')"
                  (keyup)="syncAvailableRooms()"
                />
                <button (click)="removeRow(rowIndex)" type="button" class="btn btn-danger btn-ico align-top">
                  <i class="fal fa-times"></i>
                </button>
                <button
                  *ngIf="dataItem.get('count').value > 1"
                  (click)="splitRow(rowIndex)"
                  type="button"
                  class="btn btn-primary btn-ico align-top btn-split-icon"
                  aria-label="split rows"
                ></button>
              </td>
            </tr>
          </tbody>
        </div>
      </ng-scrollbar>

      <div *ngIf="getAddedItems().length > 0" class="mt-3">
          <div class="d-flex align-items-center justify-content-between" style="cursor: pointer;" (click)="toggleAddedHotels()">
            <div class="modal-section-title">
                {{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS' | translate }} ({{ getAddedItems().length }})
                <button  type="button" class="btn btn-ico btn-success ng-star-inserted">
                  <i class="fal fa-chevron-up" *ngIf="addedHotelsExpanded"></i>
                  <i class="fal fa-chevron-down" *ngIf="!addedHotelsExpanded"></i>
                </button>
              
              </div>
            
          </div>

          <div *ngIf="addedHotelsExpanded" class="mt-2">
            <div class="table">
              <thead>
                <tr>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_NUMBER' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_HOTEL' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_TYPE' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_ROOM_COUNT' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_NIGHTS' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_MEAL_PLAN' | translate }}</th>
                  <th>{{ 'SALES.SALES_OFFERS_FORM.ADDED_HOTELS_COL_PRICE_PER_NIGHT' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getAddedItems(); let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.hotel?.name }}</td>
                  <td>{{ item.type?.value }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ getNightsCount(item.check_in, item.check_out) }}</td>
                  <td>{{ item.meal_plan?.value }}</td>
                  <td>
                    {{ item.price | number : '1.2-2' }}
                    <app-currency-box [currency]="item.price_currency"></app-currency-box>
                  </td>
                </tr>
              </tbody>
            </div>
          </div>
      </div>
    </div>
  </div>
  </ng-scrollbar>

</form>

<div class="modal-footer">
  <div *ngIf="form.invalid || !form.get('name').value" class="theme-color-danger">
    {{ 'SALES.SALES_OFFERS_FORM.INVALID_VALUES_MSG' | translate }}
  </div>
  <button
    type="submit"
    class="btn btn-outline-dark btn-xs"
    form="sale-offers-form"
    [disabled]="form.invalid || !form.get('name').value"
  >
    {{ 'SALES.SALES_OFFERS_FORM.SAVE' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-outline-dark btn-xs"
    [disabled]="form.invalid || !form.get('name').value"
    (click)="save(true)"
  >
    {{ 'SALES.SALES_OFFERS_FORM.SAVE_AND_NEW' | translate }}
  </button>
</div>
